import { Ikon } from '@studio/design-system/button';
import { Icon } from '@studio/design-system/icon';
import type { ReactElement } from 'react';
import { twMerge } from 'cn';
import type { HeaderProps } from './types.js';

/** `<Header>` component. */
export const Header = ({ className, drawer, handler, ...props }: HeaderProps): ReactElement => (
  <div
    className={twMerge('flex h-40 items-center border-b border-base-100 px-12 text-sm', className)}
    {...props}
  >
    <div>
      <Icon className='mr-4' icon='preset-image' />
      Presets
    </div>

    <div className='ml-auto'>
      <Ikon icon='plus' onClick={handler.onAdd} />
      <Ikon
        icon='close'
        onClick={(): void => {
          drawer.setValue(false);
        }}
      />
    </div>
  </div>
);
